export const appointmentTypes = [
  { value: 'regular', name: 'Regular' },
  { value: 'contract', name: 'Contract' },
  { value: 'trainee', name: 'Trainee' },
  { value: 'part time', name: 'Part Time' },
]

export const categoryTypes = [
  { value: 'GEN', name: 'General' },
  { value: 'ST', name: 'ST' },
  { value: 'SC', name: 'SC' },
  { value: 'OBC', name: 'OBC' },
  { value: 'OTHERS', name: 'Others' },
]
